import React, { useContext,useEffect } from 'react'
import AuthContext from '../context/auth/authContext'
import validate from './steps/validator';
import Spinner from './Spinner';
import StepText from './StepText'
import Step1 from './steps/Step1';
import Step2 from './steps/Step2';
import Step3 from './steps/Step3';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';
import Step6 from './steps/Step6';
import Step7 from './steps/Step7';
import Step8 from './steps/Step8';
import Step9 from './steps/Step9';
import Step10 from './steps/Step10';
import Step11 from './steps/Step11';
import Step12 from './steps/Step12';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import queryString from 'query-string';


function StepsList() {

    const authContext = useContext(AuthContext);
    const $firstStep = process.env.REACT_APP_FIRST_STEP;
      let url = window.location.search;
      let docusignEvent = queryString.parse(url).event;

    const { stepLoading, goBack, step, lead } = authContext;
    const validateField = (target) => {
        let value = target.value;
        let index = target.name;
        let $result = validate(index, value);
        // console.log(target);
        if (index == 'accept_payment_methods') {
            target = document.getElementById(index);
        }
        if (!$result) {
            target.classList.add("is-valid");
            target.classList.remove('is-invalid');
        } else {
            target.classList.add("is-invalid");
            target.classList.remove('is-valid');
        }
        return $result;
        
    }
    const savingsAmount = () => {
        if (lead && lead.business_monthly_volume) {
            let $volume = lead.business_monthly_volume;
            let $value;
            if ($volume != '$100,000+') {
                let $arr = $volume.split('-');
                if ($arr.length > 1) {
                    $value = parseInt($arr[1].replace('$', '').replace(',', ''));
                } else {
                    $value = parseInt($arr[0].replace('$', '').replace(',', ''));

                }
            } else {
                $value = parseInt(lead.business_monthly_volume.replace('$', '').replace(',', '').replace('+', ''));

            }
            return ($value * 3.11 / 100).toFixed(0);
        }
        return 0;
    }
    const $amount = savingsAmount();
    const stepTexts = [
        {
            title: 'Let\'s Get Started',
            subtitle: ''
        },
        // {
        //     title: 'See You Savings',
        //     subtitle: 'Tell us about your business and see how much you can save with our Zero Cost Processing program!'
        // },
        {
            title: 'Let\'s Get Started',
            subtitle: ''
        },
        {
            title: 'Woohoo!',
            fontsize: '2.3em',
            subtitle: ''
        },
        {
            title: 'Customize Your Product',
            subtitle: 'Please choose the options that suits you better.'
        },
        // STEP 5
        {
            title: 'Business Information',
            subtitle: 'You are only few minutes away from eliminating your processing fees forever!'
        },
        // STEP 6
        {
            title: 'Owner Information',
            subtitle: 'Please fill out information about the owner'
        },
        // STEP 7 
        {
            title: 'Processing Information',
            subtitle: 'Please fill out required information'
        },
        // STEP 8
        {
            title: 'Wrapping Things Up',
            subtitle: 'Please fill out the last remaining information including where you like your funds to be deposited into.'
        },
        // STEP 9
        {
            title: 'Upload Your Documents',
            subtitle: 'You are almost done. Please upload your documents so we can verify your identity. You can also use your phone to take a picture of your documents and upload them into our system. Your Information is 100% Secure.'
        },
        // STEP 10 
        {
            title: 'Summary',
            subtitle: `Your Estimated Monthly Savings $${$amount}`

        },
        // STEP 11 
        {
            title: 'Your application is ready!',
            subtitle: 'Please click below to review and complete your application. You will be directed to DocuSign for secure signing.'
        },

        // STEP 12 
        {
            title: 'Thank you for completing the application!',
            subtitle: 'Your application is being processed and we will reach out to you if there is anything else needed. In the meantime please share with other business owners and help them take advantage of this great program as well!'
        }

    ];
    const gaEvent = ($step) => {
        console.log('called ga ' + $step);
        // if (window.location.hostname !== "localhost") {
            

        switch ($step) {
            case $firstStep:
                if(lead){
                    ReactGA.event({
                        category: 'Navigation',
                        action: 'Changed step to ' + $step,
                    });
                    ReactPixel.track('Changed step to ' + $step);
                }
                break;
            case 12:                
                if(docusignEvent == 'signing_complete'){
                    if(!localStorage.getItem('ga_evt')){
                        localStorage.setItem('ga_evt', 'signing_complete');
                        ReactGA.event({
                          category: 'conversion',
                          action: 'user signed contract',
                        });
                    }
                  }
            break;
            default:
                ReactGA.event({
                    category: 'Navigation',
                    action: 'Changed step to ' + $step,
                });
                ReactPixel.track('Changed step to ' + $step);

        }
        // }
    }
    useEffect(() => {
        ReactPixel.init('508536697544073');
        ReactGA.initialize('UA-196278996-1');
        ReactGA.pageview(window.location.pathname);
        ReactPixel.pageView();

    }, [])
    

    // const $firstStep = 1; 
    useEffect(() => {
        // console.log('called effect '+step)
        if(step >= $firstStep){
            gaEvent(step)          
        }
    }, [step])
    
    return (<>
        {step < 13 ?
            <StepText text={stepTexts[(step - 1)]} step={step} />
            : <StepText text={stepTexts[11]} step={step} />}
        <div className={stepLoading ? 'step-wrap' : 'step-wrap loaded'}>
            <Spinner />
            {/* {gaEvent(step)} */}

            {$firstStep == 1 ? (step == 1 ? <Step1 /> : (step == 2 ? <Step2 validateField={validateField} /> : '')) : ''}
            {$firstStep == 2 ? (step <= 2 ? <Step2 validateField={validateField} /> : '') : ''}
            {step == 3 ? <Step3 /> : ''}
            {step == 4 ? <Step4 /> : ''}
            {step == 5 ? <Step5 validateField={validateField} /> : ''}
            {step == 6 ? <Step6 validateField={validateField} /> : ''}
            {step == 7 ? <Step7 validateField={validateField} /> : ''}
            {step == 8 ? <Step8 validateField={validateField} /> : ''}
            {step == 9 ? <Step9 validateField={validateField} /> : ''}
            {step == 10 ? <Step10 validateField={validateField} /> : ''}
            {step == 11 ? <Step11 /> : ''}
            {step >= 12 ? <Step12 /> : ''}

            {/* <Step11 /> */}
        </div>
    </>)
}

export default StepsList
